import { Box, Typography } from '@mui/material';
import { XIcon } from 'lucide-react';
import { BUTTON_RESET } from '../../utils/ssbStyles';

type RemovableChipVariant = 'outlined' | 'error' | 'filled' | 'neutral';

interface RemovableChipProps {
  label: string;
  description?: string;
  variant: RemovableChipVariant;
  onRemove: () => void;
}

const VARIANTS = {
  outlined: {
    chip: {
      gap: '12px',
      border: '1px solid #93C5FD',
      borderRadius: '24px',
      backgroundColor: '#EFF6FF',
      color: '#1D4ED8',
      padding: '6px 14px',
    },
    label: { fontSize: '12px' },
    iconSize: 14,
    remove: { '&:hover': { opacity: 0.7 } },
  },
  error: {
    chip: {
      gap: '12px',
      border: '1px solid #FEB2B2',
      borderRadius: '24px',
      backgroundColor: '#FFF5F5',
      color: '#C53030',
      padding: '6px 14px',
    },
    label: { fontSize: '12px' },
    iconSize: 14,
    remove: { '&:hover': { opacity: 0.7 } },
  },
  filled: {
    chip: { gap: '12px', borderRadius: '24px', backgroundColor: '#132B50', color: '#fff', padding: '3px 10px' },
    label: { fontSize: '12px', fontWeight: 500, whiteSpace: 'nowrap' },
    iconSize: 13,
    remove: {},
  },
  neutral: {
    chip: { gap: '10px', border: '1px solid #CBD5E0', borderRadius: '6px', padding: '3px 8px' },
    label: { fontSize: '13px', fontWeight: 600 },
    iconSize: 13,
    remove: { color: '#718096' },
  },
};

function RemovableChip({ label, description, variant, onRemove }: RemovableChipProps) {
  const styles = VARIANTS[variant];

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', ...styles.chip }}>
      <Typography sx={styles.label}>{label}</Typography>
      {description && <Typography sx={{ fontSize: '12px', color: '#4A5568' }}>{description}</Typography>}
      <Box
        component='button'
        type='button'
        aria-label={`Remove ${label}`}
        onClick={onRemove}
        sx={{ ...BUTTON_RESET, ...styles.remove }}
      >
        <XIcon size={styles.iconSize} />
      </Box>
    </Box>
  );
}

export default RemovableChip;
